import { ReactNode } from 'react';

type DetailProps = {
    title: ReactNode;
    value: ReactNode;
    className?: string;
};

const Detail: React.FC<DetailProps> = ({ title, value, className = '' }) => (
    <div className={`exchange-detail ${className}`}>
        <div className='title'>{title}</div>
        <div className='value'>{value}</div>
    </div>
);

export default Detail;
